var _a;
import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { iconFilledClassName } from '@fluentui/react-icons';
export var useActionMenuItemStyles = makeStyles({
    badge: __assign(__assign({}, shorthands.padding('0 2px')), { fontSize: tokens.fontSizeBase100, fontWeight: tokens.fontWeightBold, height: '16px', minWidth: '32px' }),
    badgeContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingRight: '2px',
    },
    icon: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '20px',
    },
    menuItem: {
        backgroundColor: tokens.colorNeutralBackground1,
        ':hover': (_a = {
                backgroundColor: tokens.colorNeutralBackground1Hover
            },
            _a["& .".concat(iconFilledClassName)] = {
                color: tokens.colorNeutralForeground2BrandPressed,
            },
            _a),
        ':active': {
            backgroundColor: tokens.colorNeutralBackground1Pressed,
        },
        ':focus-visible': {
            outlineColor: tokens.colorStrokeFocus2,
            outlineStyle: 'solid',
            outlineWidth: '2px',
            outlineOffset: '-1px',
        },
    },
    menuDivider: {
        backgroundColor: tokens.colorNeutralStroke2,
        height: tokens.strokeWidthThin,
    },
});
//# sourceMappingURL=ActionMenuItem.styles.js.map